import { Col, Row } from '@advanza/grid'
import { changeEntity } from '@advanza/redux_entity'
import { BasicMdParser, Button, Divider, Icon } from '@advanza/ui'
import Card from 'components/Card'
import LoadBoxWrapper from 'components/ui/LoadBoxWrapper'
import { useChangeEntity } from 'hooks/entityHooks'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import { saveKeyword } from 'hooks/keywordHooks'
import { useOptions } from 'hooks/optionHooks'
import React, { useState } from 'react'
import KeywordVariationEntity from './KeywordVariationEntity'

const fieldsFunc = (_options, questions) => {
    return {
        keyword: { type: 'text', placeholder: 'Name', msg: 'Name' },
        option_id: {
            type: 'select',
            msg: 'filter',
            className: 'select-min select-stealth',
            options: Object.keys(_options).map((key) => {
                return {
                    value: _options[key].option_id,
                    title:
                        questions[_options[key].question_id].question + ' | ' + _options[key].value,
                }
            }),
        },
        active: { type: 'boolean', msg: 'Active' },
        category: { type: 'boolean', msg: 'Category' },
    }
}

const _isTouched = (entity, keywordVariations) => {
    const entityHasChanged =
        entity.services_keywords_variations &&
        entity.services_keywords_variations.filter(
            (id) => keywordVariations[id] && keywordVariations[id]._isTouched,
        ).length

    return entityHasChanged || entity._isTouched
}

const KeywordEntity = ({ id, serviceId }) => {
    const dispatch = useAppDispatch()
    const { options: _options = {}, questions = {} } = useOptions(serviceId, true)
    const fields = fieldsFunc(_options, questions)
    const { services_keywords_variations = {} } = useAppSelector((state) => state.keywords.entities)
    const { onChangeEntity, entity, onSaveEntity, renderInput } = useChangeEntity(
        {
            store: 'keywords',
            name: 'keywords',
            entityId: id,
            saveFunc: saveKeyword,
        },
        fields,
    )

    const untouchEntities = () => {
        entity.services_keywords_variations.forEach((id) => {
            dispatch(
                changeEntity({
                    store: 'keywords',
                    name: 'services_keywords_variations',
                    key: id,
                    diff: { _beforeSave: services_keywords_variations[id] },
                    dontTouch: true,
                }),
            )
        })
    }

    const isTouched = _isTouched(entity, services_keywords_variations)

    const onSave = () => onSaveEntity().then(untouchEntities)
    const addNew = () => {
        onChangeEntity({
            services_keywords_variations: entity.services_keywords_variations.concat([
                `new_${Date.now()}`,
            ]),
        })
    }

    const onEnter = () => onSave() && addNew()
    const onDelete = (key) => {
        onChangeEntity({
            services_keywords_variations: entity.services_keywords_variations.filter(
                (id) => id !== key,
            ),
        })
        onSave()
    }
    return (
        <Card>
            <Row>
                <Col xs>
                    <h4>Keyword</h4>
                    <Divider m />
                    <Row middle={'xs'}>
                        <Col xs={8}>{renderInput('keyword')}</Col>
                        <Col xs={2}>{renderInput('active')}</Col>
                        <Col xs={2}>{renderInput('category')}</Col>
                    </Row>
                    <Divider m />
                    {renderInput('option_id')}
                </Col>
                <Col xs>
                    <h4>Keyword variations</h4>
                    <Divider m />
                    {entity.services_keywords_variations &&
                        entity.services_keywords_variations.map((key) => (
                            <KeywordVariationEntity
                                id={key}
                                keywordId={id}
                                onDelete={onDelete}
                                onEnter={onEnter}
                            />
                        ))}
                    <Button onClick={addNew} name="text">
                        Add variation
                    </Button>
                </Col>
            </Row>
            <Divider m />
            <Button type="text" onClick={onSaveEntity} disabled={!isTouched || entity._saving}>
                {entity._saving ? '...saving' : 'Save'}
            </Button>
        </Card>
    )
}

export default KeywordEntity
